
<template lang="pug">
.header

  //- ヘッダ
  q-layout-header.no-shadow
    q-toolbar(:style="toolbarStyle")

      //- 左上ボタン
      q-btn(
        flat round dense
        icon="menu"
        @click="showLeftDrawer = !showLeftDrawer"
      )

      //- タイトル
      q-toolbar-title
        .header__title.flex.justify-between
          .flex.items-center
            .q-mr-lg {{title}}
            router-view(name="header")

          //- バージョン表記
          .header__version.q-caption(
            v-if="versionString"
            :class="{'header__version--maintenance': versionString.includes('MAINTENANCE')}"
          ) ver {{versionString}}

  //- 左ドロワー
  q-layout-drawer(
    v-model="showLeftDrawer"
    behavior="mobile"
    side="left"
    no-swipe-open
    no-swipe-close
  )
    q-list(link no-border separator)
      q-list-header 「{{config.auth.name}}」としてログイン中
      q-item(
        v-for="route of routes"
        :key="route.name"
        :class="{'router-link-active': route.name === $route.name}"
        @click.native="onClickRouterLink(route)"
      )
        q-item-main {{route.meta.title}}
      q-item-separator
      q-item(@click.native="manual")
        q-item-main 説明書
      q-item(@click.native="logout")
        q-item-main ログアウト

</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import {isRouteDisplay} from 'router'
import AxiosMixin from 'mixins/axios'

export default {
  mixins: [AxiosMixin],

  data() {
    return {
      showLeftDrawer: false,
    }
  },

  computed: {
    ...mapState(['config']),
    ...mapGetters(['versionString']),

    toolbarStyle() {
      // production環境以外ではツールバーの色を変える
      return this.$store.state.config.app_debug
        ? {'--q-color-primary': '#20a0a0'}
        : {}
    },

    title() {
      for(const route of reverse(this.$route.matched)) {
        if(isRouteDisplay(route)) {
          return route.meta.title
        }
      }
      return 'レジ稼働計画'
    },

    routes() {
      return this.$router.options.routes.filter(isRouteDisplay)
    },
  },

  methods: {
    ...mapActions(['fetchConfig']),

    onClickRouterLink(route) {
      this.$store.commit('route', {name: route.name})
    },

    manual() {
      window.open('/manual.pdf', '_blank', 'toolbar=no')
    },

    async logout() {
      try {
        await this.$q.dialog({
          title: 'ログアウトの確認',
          message: 'ログアウトしてよろしいですか？',
          ok:     {label: 'ログアウト', color: 'primary', flat: true},
          cancel: {label: 'キャンセル', color: 'dark',    flat: true},
        })
        await this.axios.post('/api/logout')
        await this.fetchConfig()
      }
      catch(e) {this.$handler(e)}
    },
  },
}

function* reverse(array) {
  let i = array.length
  while(0 < i--) {
    yield array[i]
  }
}

</script>

<style lang="sass">
.header
  user-select: none

.header__title
  height: 1.92em

.header__version
  font-size: 0.625rem // サイズ調整

@keyframes header__version--maintenance--effect
  0%
    color: white
  70%
    color: red
  100%
    color: red

.header__version--maintenance
  animation: .5s linear infinite header__version--maintenance--effect
  font-weight: bold

</style>
